import React from 'react';
import { type UseReactToPrintOptions, useReactToPrint } from 'react-to-print';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as PrintIcon } from '@assets/svg/print-icon.svg';

import useTranslation from '@hooks/useTranslation';

import LoaderGif from '../../../LoaderGif/LoaderGif';
import style from './style.module.scss';

interface IProps {
  printRef?: React.RefObject<HTMLDivElement>;
  printParams?: UseReactToPrintOptions;
  isLoading?: boolean;
}

const BtnHeaderPrint: React.FC<IProps> = ({ printRef, printParams, isLoading }) => {
  const { t } = useTranslation();

  if (!printRef) {
    return null;
  }

  const onPrint = useReactToPrint({
    contentRef: printRef,
    ...printParams,
  });

  return (
    <div className={style.printIconWrapper}>
      <PrintIcon id="header-print-icon" className={style.printIcon} onClick={() => onPrint()} />
      {isLoading && <LoaderGif className={style.loader} />}
      <Tooltip anchorSelect="#header-print-icon" content={t('Print')} />
    </div>
  );
};

export default BtnHeaderPrint;
